var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":_vm.id,"option":_vm.option,"obj":_vm.chartObj}})])
}
var staticRenderFns = []

export { render, staticRenderFns }